import { render } from "./NumericKeyboard.vue?vue&type=template&id=9ee4100a"
import script from "./NumericKeyboard.vue?vue&type=script&lang=js"
export * from "./NumericKeyboard.vue?vue&type=script&lang=js"

import "./NumericKeyboard.vue?vue&type=style&index=0&id=9ee4100a&lang=css"

import exportComponent from "C:\\EventPass_actual\\v2\\eventpass-boleteria-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QIcon});
